import { View, Text, StyleSheet, Image, TouchableOpacity, Dimensions, PixelRatio } from 'react-native';
import React from 'react';
import { useNavigation } from '@react-navigation/native';
import Toast from 'react-native-toast-message';
import toastConfig from '../../toasts/toastConfig';
import Colours from '../../utils/Colours';

const { width, height } = Dimensions.get('window');
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const GetStartedScreen = () => {
    const navigation = useNavigation();
    // const imageAspectRatio = 1280 / 649; // Replace with your image's actual aspect ratio
    // const imageAspectRatio = 600 / 600; // Replace with your image's actual aspect ratio


    return (
        <View style={styles.screenContainer}>
            <Image
                // source={require('../../../assets/woman.jpg')}
                source={{ uri: 'https://cdn.pixabay.com/photo/2021/07/27/13/40/woman-6496881_1280.jpg' }}
                // style={[styles.image, { aspectRatio: imageAspectRatio }]}
                // resizeMode="cover"
                style={styles.image}

            />
            <View style={styles.container}>
                <Text style={styles.title}>The Doings app</Text>
                <Text style={styles.description}>
                    "Doings" - a unique way to tell a story through money. You do this on meeza through Tables and Pulls.
                </Text>
                <TouchableOpacity
                    style={styles.getStartedBtn}
                    onPress={() => navigation.push('sign_in')}
                >
                    <Text style={styles.getStartedText}>Get Started</Text>
                </TouchableOpacity>
            </View>
            <Toast config={toastConfig} />
        </View>
    );
};

const styles = StyleSheet.create({
    screenContainer: {
        flex: 1, // Take up the entire screen
    },
    container: {
        backgroundColor: "white",
        marginTop: dynamicSpacing(-35),
        height: '50%',
        borderTopLeftRadius: dynamicSize(30),
        borderTopRightRadius: dynamicSize(30),
        padding: dynamicSpacing(25),
    },
    image: {
        width: '100%',
        // height: dynamicSize(550),
        height: Math.min(dynamicSize(550), height * 0.72), // Limits height to 60% of screen height for tablets

    },
    getStartedBtn: {
        padding: dynamicSpacing(15),
        backgroundColor: Colours.PRIMARY,
        borderRadius: dynamicSize(99),
        marginTop: '5%',
    },
    title: {
        fontSize: dynamicFontSize(25),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Bold',
        textAlign: 'center',
        marginTop: dynamicSpacing(10)
    },
    description: {
        fontSize: dynamicFontSize(17),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
        textAlign: 'center',
        marginTop: dynamicSpacing(20)
    },
    getStartedText: {
        fontSize: dynamicFontSize(17),
        color: "white",
        fontFamily: 'Sen-Regular',
        textAlign: 'center'
    }
});

export default GetStartedScreen;